import { useEffect, useState } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { clear, checkAuth } from '../redux/slices/auth.slice'
import { useDispatch, useSelector } from "react-redux";
import FullLayout from '../layouts/full-layout/FullLayout';


const PrivateRouteEmployee = () => {

    const dispatch = useDispatch()
    const { loading, error } = useSelector(state => state.auth_store);
    const [checked, set_checked] = useState(false)
    const [user, set_user] = useState(false)

    useEffect(() => {
        dispatch(checkAuth()).unwrap().then(res => {
            console.log(res)
            set_user(res)
            set_checked(true)
        }).catch(err => {
            set_user(null)
            set_checked(true)
        })

    }, [])

    const renderDashboard = () => {
        if (user?.role && user?.role != 'fournisseur' && user?.role != 'admin' && user?.role != 'root')
            return <FullLayout />
        else
            return <Navigate to="/auth" />
    }

    return checked ? user ? renderDashboard() : <Navigate to="/auth" /> : <></>
};

export default PrivateRouteEmployee;